export default [
    {
        key: 'tableView',
        ignore: true
    },
    {
        key: 'hidden',
        ignore: true
    },
    {
        key: 'autofocus',
        ignore: true
    },
    {
        key: 'tabindex',
        ignore: true
    },
    {
        key: 'modalEdit',
        ignore: true
    },
    {
        key: 'customClass',
        ignore: true
    },
];
